<template>
  <!-- 添加优惠券 -->
  <jd-dialog
    :title="showButton ? '创建发放型优惠券' : '查看'"
    width="575"
    :visible="isShow"
    append-to-body
    @close="addCouponChange"
  >
    <div class="coupon-tip-wrap">
      <jd-tip>
        <p>因官方接口限制，FCS店铺不支持优惠券奖品，请勿使用优惠券</p>
      </jd-tip>
    </div>
    <div class="add-coupon new-input-box">
      <!-- 头部 -->
      <!-- <header class="navTab">
        <span :class="{ active: navIsAcitev == 1 }" @click="navIsAci(1)"
          >东券</span
        >
        <span :class="{ active: navIsAcitev == 0 }" @click="navIsAci(0)"
          >京券</span
        >
        <div class="line"></div>
      </header> -->
      <!-- 表单 -->
      <div class="form">
        <el-form :model="formOne" :rules="rules" ref="form" label-width="124px">
          <el-form-item label="优惠券类型" required v-if="navIsAcitev == 1">
            <el-radio-group v-model="formOne.bindType" :disabled="isStart">
              <el-radio :label="1">店铺券</el-radio>
              <el-radio :label="2">商品券（最多支持300个sku）</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="优惠券名称" required>
            <el-input
              v-model="formOne.name"
              :disabled="isStart"
              style="width: 290px"
              placeholder="请输入优惠券名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="领券时间" required>
            <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="formOne.takeBeginTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 155px; font-size: 12px"
                class="time1"
                change="activityTimeChange"
                :clearable="false"
                :disabled="isStart"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="formOne.takeEndTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 155px; font-size: 12px"
                class="time2"
                change="activityTimeChange"
                :clearable="false"
                :disabled="isStart"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearTime()"
                v-if="!isStart"
              ></i>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
          </el-form-item>

          <el-form-item label="券有效期" required>
            <el-select
              v-model="formOne.validityType"
              :disabled="isStart"
              style="width: 100px; margin-right: 10px"
              placeholder="请选择"
            >
              <el-option label="相对时间" :value="1" />
              <el-option label="绝对时间" :value="5" />
            </el-select>
            <template v-if="formOne.validityType == 1">
              领取后&nbsp;
              <el-input
                v-model.number="formOne.days"
                @input="formOne.days = getNumberData(1, $event, 0, 1, 30)"
                :disabled="isStart"
                style="width: 60px"
              ></el-input>
              <span class="txt">天内有效</span>
            </template>

            <template v-if="formOne.validityType == 5">
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formOne.beginTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 135px; font-size: 12px"
                  class="time1"
                  change="activityTimeChange"
                  :clearable="false"
                  :disabled="isStart"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formOne.endTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 140px; font-size: 12px"
                  class="time2"
                  change="activityTimeChange"
                  :clearable="false"
                  :disabled="isStart"
                >
                </el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="(formOne.beginTime = ''), (formOne.endTime = '')"
                  v-if="!isStart"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
            </template>
          </el-form-item>

          <el-form-item label="优惠方式" required v-if="navIsAcitev == 1">
            <el-radio v-model="fullDiscount" :label="1" :disabled="isStart"
              >满减券</el-radio
            >
          </el-form-item>
          <el-form-item label="是否支持转赠" required>
            <el-radio v-model="formOne.shareType" :label="1" :disabled="isStart"
              >是</el-radio
            >
            <el-radio v-model="formOne.shareType" :label="2" :disabled="isStart"
              >否</el-radio
            >
          </el-form-item>
          <el-form-item label="单次发放张数:" required>
            <el-select v-model="formOne.numPerSending" :disabled="isStart" style="width: 100px;margin-right: 10px;" placeholder="请选择">
              <el-option 
                v-for="num in 10" 
                :key="num" 
                :label="num.toString()" 
                :value="num" 
              />
            </el-select>
          </el-form-item>
          <el-form-item label="优惠信息" required v-if="navIsAcitev == 1">
            <div>
              满
              <el-input
                v-model="formOne.quota"
                :disabled="isStart"
                style="width: 110px"
                @input="formOne.quota = getNumberData(1, $event, 1, 1)"
              ></el-input>
              减
              <el-input
                v-model="formOne.discount"
                :disabled="isStart"
                @input="formOne.discount = getNumberData(1, $event, 1, 1)"
                style="width: 110px"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="优惠券面值" required v-if="navIsAcitev == 0">
            <el-input
              v-model="formOne.discount"
              :disabled="isStart"
              @input="formOne.discount = getNumberData(1, $event, 1, 1)"
              style="width: 136px"
            ></el-input>
            元
          </el-form-item>
          <el-form-item label="发放数量" required>
            <el-input
              v-model.number="formOne.num"
              @input="formOne.num = getNumberData(1, $event, 0, 1)"
              style="width: 110px"
              @blur="beAdd"
            ></el-input>
            张
          </el-form-item>
          <el-form-item label="发放人数" v-if="isShowNum">
            <el-input :value="provideNum" :disabled="true" style="width: 110px"></el-input>
            人
          </el-form-item>
          <el-form-item label="优惠券适用商品" required v-if="formOne.bindType == 2 && navIsAcitev == 1" style="margin-bottom: 0;">
            <span style="margin-right: 40px; font-size: 14px">
              共 <span style="color: #2768ff">{{ numSku }}</span> 个sku</span
            >
            <el-button
              style=""
              type="primary"
              @click="openGoods"
              :disabled="isStart"
              >选择商品</el-button
            ></el-form-item
          >
        </el-form>
      </div>
    </div>

    <!-- 选择商品弹窗 -->
    <select-goods
      :isShow="goodsState"
      :selectGoods="returnSelectGoods"
      :skuId="skuIdGoods"
      :skuSearch="true"
      @close="selectGoodsChange"
      :moduleType="true"
      :numlimit="300"
      :xianz="true"
      isInteract
    ></select-goods>
    <!-- 底部 -->
    <div slot="footer">
      <div class="zzc" v-if="!showButton"></div>
      <footer class="foot" v-if="showButton">
        <jd-button @click="addCouponChange">取消</jd-button>
        <jd-button type="blue" @click="setCoupon" style="margin-left: 8px"
          >确认</jd-button
        >
      </footer>
    </div>
  </jd-dialog>
</template>

<script>
import myPopup from "@/components/jhk/myPopup.vue";
import inputForm from "@/components/jhk/inputForm.vue";
import SelectGoods from "@/components/selectGoodsMonitor2.vue";
import { createSellerCouponWrite } from "@/api/jhk/integralCenter/couponWriteController.js";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";

export default {
  props: {
    showButton: {
      type: Boolean,
      default: true,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    isSuperFission: {
      type: Boolean,
      default: false,
    },
    isyouhui: {
      type: Boolean,
      default: false,
    },
    // 回显
    fromInfo: {},
    // 是否进行中活动
    isStart: {
      type: Boolean,
      default: false,
    },
    // 是否显示发放人数
    isShowNum: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isShow(value) {
      console.log(value, this.isSuperFission, this.fromInfo, "111-");
      if (value && this.isSuperFission && this.fromInfo.validityType) {
        this.formOne = { ...this.fromInfo };
        if (this.fromInfo.bindType == 2) {
          if (this.fromInfo.skuIds) {
            this.skuIdGoods = this.fromInfo.skuIds.split(",");
            var skuIds = this.fromInfo.skuIds.split(",");
            this.numSku = skuIds.length;
            getTaobaoItemListSku({
              current: 1,
              skuIds: this.skuIdGoods,
              size: 99,
            }).then((res) => {
              this.rightLoading = false;
              if (res.code == 1) {
                res.data.records.map((item) => {
                  item.wareTitle = item.skuName;
                });
                this.returnSelectGoods = res.data.records;
              } else {
                this.returnSelectGoods = [];
              }
            });
          } else {
            this.numSku = this.fromInfo.returnSelectGoods.length;
            this.returnSelectGoods = this.fromInfo.returnSelectGoods;
          }
        }
      } else {
        this.formOne = {
          bindType: 1,
          name: "",
          takeBeginTime: "",
          takeEndTime: "",
          days: null,
          quota: null,
          numPerSending: 1, // 单次发放张数
          discount: null,
          num: null,
          validityType: 1,
          beginTime: "",
          endTime: "",
          shareType: 1,
        };
        this.numSku = 0;
        this.returnSelectGoods = [];
      }
    },
  },
  components: {
    myPopup,
    inputForm,
    SelectGoods,
  },
  data() {
    return {
      numSku: 0,
      goodsState: false,
      returnSelectGoods: [],
      // totalShopList: 0,
      // currentShopPage: 1,
      fullDiscount: 1,
      navIsAcitev: 1,
      formOne: {
        bindType: 1,
        name: "",
        takeBeginTime: "",
        takeEndTime: "",
        days: null,
        quota: null,
        numPerSending: 1, // 单次发放张数
        discount: null,
        num: null,
        validityType: 1,
        beginTime: "",
        endTime: "",
        shareType: 1,
      },
      rules: {},
      startTime: null,
      endTime: null,
      // tableShopData: [],
      ids: 0,
      postForm: {
        orderStartTime: "",
        testSelect: 0,
      },
      goodsStateLength: 0,
      goodsStateLength1: 0,
      returnSelectGoodsAppoint: [], //选择商品回显
      skuIdGoods: "", //商品ID
    };
  },
  computed: {
    // 发放人数
    provideNum() {
      if (this.formOne.numPerSending && this.formOne.num) {
        return Math.floor(this.formOne.num / this.formOne.numPerSending);
      }
      return '';
    }
  },
  methods: {
    beAdd() {
      if (this.isStart && this.formOne.minNum > this.formOne.num) {
        this.formOne.num = this.formOne.minNum;
        this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
      }
    },
    openGoods() {
      this.goodsState = true;
    },
    // 关闭弹窗
    addCouponChange() {
      this.$emit("close", false);
      this.formOne.name = "";
      this.formOne.takeBeginTime = "";
      this.formOne.takeEndTime = "";
      this.formOne.days = null;
      this.formOne.discount = null;
      this.formOne.num = null;
      this.formOne.quota = null;
      this.formOne.numPerSending = 1; // 单次发放张数
      this.formOne.bindType = null;
      this.formOne.shareType = 1;
    },
    navIsAci(val) {
      if (val == 1) {
        this.navIsAcitev = 1;
        this.formOne.quota = null;
        this.formOne.bindType = null;
      } else {
        this.navIsAcitev = 0;
        this.formOne.quota = 0;
        this.formOne.bindType = 1;
      }
      this.formOne.name = "";
      this.formOne.takeBeginTime = "";
      this.formOne.takeEndTime = "";
      this.formOne.days = null;
      this.formOne.numPerSending = 1; // 单次发放张数
      this.formOne.discount = null;
      this.formOne.num = null;
    },
    checkputn1(e) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
      // if (e.target.value > 30) {
      //   e.target.value = 30;
      // }
    },

    checkputn30(e) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
        // this.formOne.days = 0;
      }
      if (e.target.value > 30) {
        e.target.value = 30;
        this.formOne.days = 30;
      }
      // console.log(this.formOne.days);
    },

    //创建优惠券
    setCoupon() {
      if (!this.formOne.name) return this.$message.warning("请输入优惠券名称");
      if (!this.formOne.takeBeginTime || !this.formOne.takeEndTime)
        return this.$message.warning("请选择领券时间");
      if (!this.formOne.quota || !this.formOne.discount)
        return this.$message.warning("请输入优惠信息");
      if (this.formOne.validityType == 1 && !this.formOne.days)
        return this.$message.warning("请输入券有效期");
      if (
        this.formOne.validityType == 5 &&
        (!this.formOne.beginTime || !this.formOne.endTime)
      )
        return this.$message.warning("请输入券有效期");

      if (this.formOne.discount != null) {
        this.formOne.discount = Number(this.formOne.discount);
      }
      // if (this.formOne.num != null) {
      //   this.formOne.num = Number(this.formOne.num);
      // }
      if (this.formOne.quota != null) {
        this.formOne.quota = Number(this.formOne.quota);
      }
      if (parseInt(this.formOne.days) <= 0) {
        this.$message.error("优惠券有效期无效");
        return;
      }
      if (this.formOne.num <= 0) {
        this.$message.error("优惠券发放数量无效");
        return;
      }
      if(this.formOne.num < this.formOne.numPerSending){
        return this.$message.warning('"发放数量"需大于"单次发放张数"');
      }
      this.formOne.type = Number(this.navIsAcitev);
      console.log(this.formOne);

      if (this.isSuperFission) {
        if (this.formOne.bindType == 2) {
          this.formOne.returnSelectGoods = this.returnSelectGoods;
        }
        this.$emit("funcMes", { ...this.formOne, provideNum:this.provideNum });
        if(!this.isyouhui) {
          this.$emit("close", false);
        }
      } else {
        createSellerCouponWrite(this.formOne).then((res) => {
          if (res && res.code == 1) {
            this.ids = Number(res.data);
            this.$message.success(res.message);
            this.addCouponChange(); //关闭弹窗
            setTimeout(() => {
              this.$emit("funcMes", this.ids);
            }, 800);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    clearTime() {
      this.formOne.takeBeginTime = "";
      this.formOne.takeEndTime = "";
    },
    // 商品组件回调
    selectGoodsChange(val) {
      console.log("商品选择返回==", val);
      if (val !== false) {
        let aaa = [];
        let itemListFor = [];
        val.forEach((item, index) => {
          let fomeVaule = {};
          aaa.push(Number(item.skuId));
          fomeVaule.skuId = val[index].skuId;
          fomeVaule.logo = val[index].logo;
          fomeVaule.price = val[index].jdPrice || val[index].price;
          fomeVaule.title = val[index].wareTitle || val[index].title;
          itemListFor.push(fomeVaule);
        });
        this.returnSelectGoods = itemListFor;
        this.formOne.skuId = aaa.toString();
        // let arr =
        this.formOne.skuId.split(",");
        // console.log(arr, "aaa");

        // this.formOne.skuId = arr;

        this.postForm.itemList = val;
        this.numSku = val.length;
        this.goodsStateLength = this.goodsStateLength1;
        this.returnSelectGoodsAppoint = val;
      }
      this.goodsState = false;
    },
    // handleSizeChange(val) {},
    // handleCurrentChange(val) {},
  },
};
</script>

<style lang="scss" scoped>
.coupon-tip-wrap {
  margin-bottom: 8px;
}
.zzc {
  position: absolute;
  top: 54px;
  left: 0;
  width: 100%;
  height: 76%;
}
.add-coupon {
  .navTab {
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 35px;
    margin: 20px 0;
    span {
      flex-shrink: 0;
      width: 106px;
      height: 35px;
      line-height: 34px;
      text-align: center;
      margin-right: 2px;
      border: 1px solid rgba(221, 221, 221, 1);
      border-radius: 2px 2px 0px 0px;
      cursor: pointer;
      &:last-child {
        margin: 0;
      }
    }
    .active {
      border-bottom: none !important;
      border-top: 2px solid #fe4d45;
      border-radius: 4px 4px 0px 0px;
    }
    .line {
      flex: 1;
      border-bottom: 1px solid #ddd;
    }
  }
  .form {
    font-size: 14px;
    color: #333;
    .txt {
      margin-left: 10px;
      // color: #999;
    }
  }
  .foot {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 30px;
    .cancel {
      width: 98px;
      height: 32px;
      line-height: 28px;
      // margin-right: 12px;
      // border: 1px solid #ccc;
      // color: #999;
    }
    .confirm {
      width: 98px;
      height: 32px;
      line-height: 28px;
      // background-color: #fe4d45;
      // color: #fff;
    }
  }
  button {
    // border: none;
    // background-color: white;
    // outline: none;
    // cursor: pointer;
    border-radius: 3px;
    transition: all 0.2s;
  }
}
</style>
